import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/pagination'
import { Autoplay, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import { LargeContainer } from '../../../assets/styles/GlobalStyle'
import { useAppSelector } from '../../../store'
import { AppState } from '../../../store/appSlice'
import Loader from '../../Loader'

const PromoCodeSlider = () => {
  const navigate = useNavigate()

  const { lang } = useAppSelector((root: { app: AppState }) => root.app)

  const { data: slides, isLoading: isSlidesLoading } = api.useGetLandingSlidesQuery(undefined)

  return isSlidesLoading ? (
    <Loader />
  ) : (
    <>
      {slides && slides.length >= 1 ? (
        <LargeContainer>
          <Wrapper>
            <Swiper
              pagination={{ clickable: true }}
              modules={[Pagination, Autoplay]}
              spaceBetween={30}
              slidesPerView={1}
              loop={slides.length > 1}
              autoplay={{
                delay: 3000,
                pauseOnMouseEnter: true,
                disableOnInteraction: true,
              }}
            >
              {slides.map((item, index) => (
                <SwiperSlide key={index}>
                  <Block
                    onClick={() => navigate(`/${item.redirectUrl}`)}
                    style={{
                      backgroundImage: `url(${item.photoUrl})`,
                    }}
                  >
                    {item && item.promoCode && (
                      <PromoCodeP>
                        {item.translations?.[lang]?.title}: <span>{item.promoCode}</span>
                      </PromoCodeP>
                    )}

                    <DescriptionP>{item.translations?.[lang]?.description}</DescriptionP>

                    <Button>{item.translations?.[lang]?.btnText}</Button>
                  </Block>
                </SwiperSlide>
              ))}
            </Swiper>
          </Wrapper>
        </LargeContainer>
      ) : null}
    </>
  )
}

const Button = styled.button`
  width: 260px;
  height: 64px;
  min-height: 64px;
  border-radius: 4px;
  background-color: ${Colors.primaryRed};
  outline: none;
  border: 0px;
  color: ${Colors.white};
  font-size: 18px;
  margin-top: 30px;
  transition: all 200ms ease-in;

  &:hover {
    transition: all 200ms ease-in;
    transform: scale(1.12);
    background-color: transparent;
    color: ${Colors.primaryBlack};
    border: 1px solid ${Colors.primaryBlack};
  }
`
const Block = styled.div`
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10%;

  ${Responsive.tablet} {
    padding-top: 20%;
  }
  ${Responsive.mobile} {
    padding-top: 30px;
  }
`
const DescriptionP = styled.p`
  font-size: 44px;
  color: ${Colors.primaryBlack};
  margin-bottom: 60px;
  text-align: center;
  max-width: 50%;

  span {
    padding: 10px;
    background-color: ${Colors.secondaryBlack};
    border-top-left-radius: 8px;
    border-bottom-right-radius: 8px;
    color: ${Colors.white};
  }

  ${Responsive.laptop} {
    max-width: 70%;
  }

  ${Responsive.tablet} {
    margin-bottom: 47px;
    font-size: 32px;
    max-width: 70%;
  }

  ${Responsive.mobile} {
    margin-bottom: 30px;
    font-size: 24px;
    max-width: 90%;
  }
`
const PromoCodeP = styled.p`
  font-size: 24px;
  color: ${Colors.nevadaGrey};
  margin-bottom: 24px;
  text-align: center;

  span {
    padding: 10px;
    background-color: ${Colors.secondaryBlack};
    border-top-left-radius: 8px;
    border-bottom-right-radius: 8px;
    color: ${Colors.white};
  }

  ${Responsive.tablet} {
    margin-bottom: 20px;
    font-size: 18px;
  }

  ${Responsive.mobile} {
    margin-bottom: 15px;
    font-size: 14px;
  }
`
const Wrapper = styled.div`
  height: calc(100vh - 96px);

  .swiper-pagination-bullet {
    height: 8px;
    width: 8px;
    background-color: ${Colors.Black};
  }

  .swiper-pagination-bullet.swiper-pagination-bullet-active {
    height: 12px;
    width: 12px;
    background-color: ${Colors.primaryRed};
  }

  .swiper-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .swiper {
    position: unset;
  }

  .swiper-horizontal {
    border-radius: 8px;
    height: 100%;
  }
`

export default PromoCodeSlider
